import React from 'react';
import { Route } from 'react-router-dom';

// Delivery & Logistics pages
const DeliveryPage = React.lazy(() => import('../pages/DeliveryPage').then(m => ({ default: m.DeliveryPage })));
const VehiclesPage = React.lazy(() => import('../pages/VehiclesPage').then(m => ({ default: m.VehiclesPage })));
const TimetablesPage = React.lazy(() => import('../pages/TimetablesPage').then(m => ({ default: m.TimetablesPage })));
const ZonesPage = React.lazy(() => import('../pages/ZonesPage').then(m => ({ default: m.ZonesPage })));
const WarehouseZonesPage = React.lazy(() => import('../pages/WarehouseZonesPage').then(m => ({ default: m.WarehouseZonesPage })));
const DriversPage = React.lazy(() => import('../pages/DriversPage').then(m => ({ default: m.DriversPage })));

// Driver-specific pages
const DriverDashboard = React.lazy(() => import('../pages/DriverDashboard').then(m => ({ default: m.DriverDashboard })));
const DeliveryTracking = React.lazy(() => import('../pages/DeliveryTracking').then(m => ({ default: m.DeliveryTracking })));
const RouteManagement = React.lazy(() => import('../pages/RouteManagement').then(m => ({ default: m.RouteManagement })));
const RoutePlannerPage = React.lazy(() => import('../pages/RoutePlannerPage').then(m => ({ default: m.RoutePlannerPage })));

export const deliveryRoutes = [
  // Main Delivery Pages
  <Route key="/delivery" path="/delivery" element={<DeliveryPage />} />,
  <Route key="/vehicles" path="/vehicles" element={<VehiclesPage />} />,
  <Route key="/timetables" path="/timetables" element={<TimetablesPage />} />,
  <Route key="/zones" path="/zones" element={<ZonesPage />} />,
  <Route key="/warehouse-zones" path="/warehouse-zones" element={<WarehouseZonesPage />} />,
  <Route key="/drivers" path="/drivers" element={<DriversPage />} />,
  
  // Driver Routes
  <Route key="/driver" path="/driver" element={<DriverDashboard />} />,
  <Route key="/driver/dashboard" path="/driver/dashboard" element={<DriverDashboard />} />,
  <Route key="/driver/routes" path="/driver/routes" element={<DriverDashboard />} />,
  <Route key="/driver/route/:routeId" path="/driver/route/:routeId" element={<RouteManagement />} />,
  <Route key="/driver/delivery/:deliveryId" path="/driver/delivery/:deliveryId" element={<DeliveryTracking />} />,
  
  // Legacy Routes
  <Route key="/routes" path="/routes" element={<RoutePlannerPage />} />,
  <Route key="/routes/*" path="/routes/*" element={<RoutePlannerPage />} />,
];
